import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  text?: string;
  className?: string;
}

const sizes = {
  sm: 'h-4 w-4 border-2',
  md: 'h-7 w-7 border-2',
  lg: 'h-10 w-10 border-[3px]',
};

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', text, className = '' }) => (
  <div className={`flex flex-col items-center justify-center gap-2.5 ${className}`}>
    <span
      className={`${sizes[size]} inline-block animate-spin rounded-full border-accent border-t-transparent`}
      role="status"
      aria-label={text || 'Loading'}
    />
    {text && <span className="text-sm text-ink-soft">{text}</span>}
  </div>
);

export default LoadingSpinner;
